import React from 'react';

import { SvgIconProps } from '@ui-core/types';

import BaseIcon from '../base-icon';

const SvgIcon: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return (
    <BaseIcon {...props}>
      <rect x="11" y="6" width="2" height="8" rx="1" />
      <path d="M12 15.75C12.6904 15.75 13.25 16.3096 13.25 17C13.25 17.6904 12.6904 18.25 12 18.25C11.3096 18.25 10.75 17.6904 10.75 17C10.75 16.3096 11.3096 15.75 12 15.75Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
      />
    </BaseIcon>
  );
};

export default SvgIcon;
